module.exports = __webpack_public_path__ + "img/nguyen_banner.c25f84fb.jpg";